/**
 * Customer tag vocabulary (95 tags) generated from the molluskio tags v2
 * registry (tag_definitions.json english_description + classifier implications =
 * "always brings"). Customer families were assigned for the data dictionary in
 * mollusk-interface#171. Do not hand-edit: regenerate with
 * packages/shared/scripts/gen_tag_data.py.
 */
export const TAG_DATA = {
    families: [
        {
            key: 'scope',
            label: 'Scope',
        },
        {
            key: 'trade',
            label: 'Trade',
        },
        {
            key: 'equipment',
            label: 'Equipment',
        },
        {
            key: 'structure',
            label: 'Structure & feature',
        },
        {
            key: 'property',
            label: 'Property type',
        },
        {
            key: 'hazard',
            label: 'Hazard & environment',
        },
        {
            key: 'record',
            label: 'Record & process',
        },
    ],
    tags: [
        {
            tag: 'new_build',
            family: 'scope',
            description: 'Identifies permits or records for construction of a new building, dwelling, or other qualifying structure.',
            always_brings: [],
        },
        {
            tag: 'addition',
            family: 'scope',
            description: 'Identifies permits or records for an addition that expands an existing building or structure.',
            always_brings: [],
        },
        {
            tag: 'alteration',
            family: 'scope',
            description: 'Identifies permits or records for a broad alteration to an existing structure, including qualifying repairs, remodels, additions, tenant improvements, and room renovations. Roof replacement alone is repair, not alteration; alteration requires separate alteration work.',
            always_brings: [],
        },
        {
            tag: 'repair',
            family: 'scope',
            description: 'Identifies permits or records for repair work to an existing building, structure, or system.',
            always_brings: [],
        },
        {
            tag: 'demolition',
            family: 'scope',
            description: 'Identifies permits or records for demolition, wrecking, removal, or razing of a building or structure, including selective interior demolition. The interior_demo tag identifies the interior subset.',
            always_brings: [],
        },
        {
            tag: 'interior_demo',
            family: 'scope',
            description: 'Identifies selective, partial, or non-structural interior demolition within a building that remains. It also carries demolition and alteration; it does not by itself indicate whole-structure removal.',
            always_brings: [],
        },
        {
            tag: 'tenant_improvement',
            family: 'scope',
            description: 'Identifies permits or records for tenant improvements, tenant finish or finish-out, upfit, and comparable work within tenant space.',
            always_brings: [],
        },
        {
            tag: 'change_of_use',
            family: 'scope',
            description: 'Identifies permits or records for a change in the permitted use or occupancy of a property or space.',
            always_brings: [],
        },
        {
            tag: 'damage_repair',
            family: 'scope',
            description: 'Identifies permits or records for repair or rebuilding prompted by fire, storm, flood, vehicle, tree, or other named damage or disaster.',
            always_brings: ['repair'],
        },
        {
            tag: 'basement_finish',
            family: 'scope',
            description: 'Identifies permits or records for finishing or converting a basement as an alteration project.',
            always_brings: ['alteration'],
        },
        {
            tag: 'revision',
            family: 'scope',
            description: 'Identifies revisions, supplements, deferred submittals, addenda, supersedes, permit extensions/extension requests, reinstatements, renewals, reissuances, resubmittals, contractor changes, and permit amendments.',
            always_brings: [],
        },
        {
            tag: 'electrical',
            family: 'trade',
            description: 'Identifies permits or records for electrical trade work, or for equipment identified by another tag that needs electrical work.',
            always_brings: [],
        },
        {
            tag: 'plumbing',
            family: 'trade',
            description: 'Identifies permits or records for plumbing trade work, or for equipment identified by another tag that needs plumbing work.',
            always_brings: [],
        },
        {
            tag: 'mechanical',
            family: 'trade',
            description: 'Identifies permits or records for mechanical or HVAC trade work, including work on equipment identified by another tag that needs mechanical work.',
            always_brings: [],
        },
        {
            tag: 'gas',
            family: 'trade',
            description: 'Identifies permits or records for fuel-gas piping, gas service, related gas-system work, gas appliances, and LP/propane tanks or cylinders. Piped gas work also carries plumbing; a gas appliance alone does not imply plumbing.',
            always_brings: [],
        },
        {
            tag: 'roofing',
            family: 'trade',
            description: 'Identifies permits or records for roofing work of any kind, including roof work that is neither a full reroof nor a partial roof repair.',
            always_brings: [],
        },
        {
            tag: 'structural',
            family: 'trade',
            description: 'Identifies permits or records for structural work involving framing, load-bearing elements, foundations, seismic systems, or comparable structural scope.',
            always_brings: [],
        },
        {
            tag: 'fire_protection',
            family: 'trade',
            description: 'Identifies permits or records for fire-protection systems such as sprinklers, alarms, suppression, standpipes, or related fire-safety equipment.',
            always_brings: [],
        },
        {
            tag: 'low_voltage',
            family: 'trade',
            description: 'Identifies permits or records for low-voltage systems such as security, CCTV, access control, intercom, structured wiring, data cabling, and audio/video systems.',
            always_brings: [],
        },
        {
            tag: 'telecom',
            family: 'trade',
            description: 'Identifies permits or records for telecommunications infrastructure such as cell towers, monopoles, antennas, wireless facilities, small cells, and radios.',
            always_brings: [],
        },
        {
            tag: 'insulation',
            family: 'trade',
            description: 'Identifies permits or records for insulation, weatherization, or air-sealing work, excluding incidental specification text on broader projects.',
            always_brings: [],
        },
        {
            tag: 'exterior',
            family: 'trade',
            description: 'Identifies permits or records for exterior-envelope work such as facade, masonry, siding, EIFS, tuckpointing, or qualifying exterior openings.',
            always_brings: [],
        },
        {
            tag: 'site_civil',
            family: 'trade',
            description: 'Identifies permits or records for site and civil work, including qualifying utilities, drainage, excavation, and land-development infrastructure.',
            always_brings: [],
        },
        {
            tag: 'grading',
            family: 'trade',
            description: 'Identifies permits or records for grading, earthwork, land disturbance, erosion-control work, or qualifying non-utility excavation.',
            always_brings: [],
        },
        {
            tag: 'landscaping',
            family: 'trade',
            description: 'Identifies permits or records for landscaping, irrigation, lawn-sprinkler, or qualifying tree work.',
            always_brings: [],
        },
        {
            tag: 'solar',
            family: 'equipment',
            description: 'Identifies permits or records for solar-energy work, such as photovoltaic modules, arrays, inverters, or other qualifying solar-system work.',
            always_brings: ['electrical'],
        },
        {
            tag: 'battery_storage',
            family: 'equipment',
            description: 'Identifies permits or records for battery or energy-storage systems, including battery energy storage systems (BESS or ESS), home batteries, and qualifying battery-backup work.',
            always_brings: ['electrical'],
        },
        {
            tag: 'ev_charger',
            family: 'equipment',
            description: 'Identifies permits or records for electric-vehicle charging equipment or charging-station work.',
            always_brings: ['electrical'],
        },
        {
            tag: 'generator',
            family: 'equipment',
            description: 'Identifies permits or records for generator installation, replacement, or related standby-power work.',
            always_brings: ['electrical'],
        },
        {
            tag: 'heat_pump',
            family: 'equipment',
            description: 'Identifies permits or records for heat pumps, ductless systems, or mini-split equipment.',
            always_brings: ['mechanical'],
        },
        {
            tag: 'water_heater',
            family: 'equipment',
            description: 'Identifies permits or records for water-heater installation, replacement, or repair, including qualifying hot-water equipment.',
            always_brings: ['plumbing'],
        },
        {
            tag: 'boiler',
            family: 'equipment',
            description: 'Identifies permits or records for boiler installation, replacement, repair, or related boiler work.',
            always_brings: [],
        },
        {
            tag: 'elevator',
            family: 'equipment',
            description: 'Identifies permits or records for elevators, escalators, dumbwaiters, or qualifying accessibility and platform lifts.',
            always_brings: [],
        },
        {
            tag: 'storage_tank',
            family: 'equipment',
            description: 'Identifies permits or records for fuel, propane, oil, chemical, underground, or above-ground storage tanks—not water-heater or septic tanks.',
            always_brings: [],
        },
        {
            tag: 'service_change',
            family: 'equipment',
            description: "Identifies permits or records for an electrical service change, upgrade, increase or replacement, or for main panel and service-capacity work. A sub-panel, a temporary service, a brand-new service, and non-electrical uses of the word 'panel' (solar, seawall or hurricane panels) do not count.",
            always_brings: ['electrical'],
        },
        {
            tag: 'septic',
            family: 'equipment',
            description: 'Identifies permits or records for septic and onsite wastewater systems, drain fields, leach fields, and related treatment systems.',
            always_brings: [],
        },
        {
            tag: 'sewer',
            family: 'equipment',
            description: 'Identifies permits or records for sewer-line, connection, tap, lateral, repair, disconnect or service work, excluding storm sewers and septic systems.',
            always_brings: ['plumbing'],
        },
        {
            tag: 'fireplace_chimney',
            family: 'equipment',
            description: 'Identifies permits or records for fireplaces, chimneys, wood or pellet stoves, gas inserts or logs, and qualifying flues.',
            always_brings: [],
        },
        {
            tag: 'swimming_pool',
            family: 'structure',
            description: 'Identifies permits or records for swimming-pool construction or work, including pool barriers, enclosures and safety mesh. Motor pools, pool tables and pool halls, and references saying there is no pool, do not count.',
            always_brings: [],
        },
        {
            tag: 'spa_or_hottub',
            family: 'structure',
            description: "Identifies permits or records for a residential hot tub or spa, such as a jacuzzi, a spa-only permit or a built-in spa. A salon, resort, fitness or medical spa business, or a 'Pool/Spa' category whose work is only a pool, does not count.",
            always_brings: [],
        },
        {
            tag: 'deck_or_porch',
            family: 'structure',
            description: 'Identifies permits or records for decks, porches, balconies, verandas, or similar attached exterior platforms.',
            always_brings: [],
        },
        {
            tag: 'patio',
            family: 'structure',
            description: 'Identifies permits or records for patios or comparable outdoor living surfaces and structures.',
            always_brings: [],
        },
        {
            tag: 'fence_or_wall',
            family: 'structure',
            description: 'Identifies permits or records for fences and walls, including wood fences, block, masonry and screen walls, barriers, gates, and pool barriers or safety mesh. A retaining wall carries both this tag and retaining_wall.',
            always_brings: [],
        },
        {
            tag: 'retaining_wall',
            family: 'structure',
            description: 'Identifies permits or records for retaining-wall construction, repair, or replacement.',
            always_brings: ['site_civil'],
        },
        {
            tag: 'garage',
            family: 'structure',
            description: 'Identifies permits or records for garage construction, conversion, repair, or qualifying garage work.',
            always_brings: [],
        },
        {
            tag: 'shed_or_accessory',
            family: 'structure',
            description: 'Identifies permits or records for sheds and other qualifying detached accessory structures.',
            always_brings: [],
        },
        {
            tag: 'pole_barn',
            family: 'structure',
            description: 'Identifies permits or records for pole barns or post-frame buildings.',
            always_brings: [],
        },
        {
            tag: 'screen_enclosure',
            family: 'structure',
            description: 'Identifies permits or records for screen rooms, pool cages, lanais, screened patios, and qualifying aluminum or pool enclosures—not barrier fences.',
            always_brings: [],
        },
        {
            tag: 'awning_canopy',
            family: 'structure',
            description: 'Identifies permits or records for awnings, canopies, pergolas, shade structures, trellises, or comparable covered exterior structures.',
            always_brings: [],
        },
        {
            tag: 'dock',
            family: 'structure',
            description: 'Identifies permits or records for boat docks, piers, boathouses, or comparable marine-access structures.',
            always_brings: ['site_civil'],
        },
        {
            tag: 'flatwork_concrete',
            family: 'structure',
            description: 'Identifies permits or records for concrete flatwork such as slabs, pads, walkways, and similar horizontal concrete work.',
            always_brings: ['site_civil'],
        },
        {
            tag: 'paving_driveway_sidewalk',
            family: 'structure',
            description: 'Identifies permits or records for paving, driveways, sidewalks, aprons, or comparable hardscape access work.',
            always_brings: ['site_civil'],
        },
        {
            tag: 'door_or_window',
            family: 'structure',
            description: 'Identifies permits or records for doors, windows, fenestration, or related opening replacements and installations.',
            always_brings: [],
        },
        {
            tag: 'siding',
            family: 'structure',
            description: 'Identifies permits or records for siding installation, replacement, or repair.',
            always_brings: ['exterior'],
        },
        {
            tag: 'reroof',
            family: 'structure',
            description: 'Identifies permits or records for full roof replacement or reroofing, including tear-off, overlay, reshingle and remove-and-replace work. A permit typed only as a residential or commercial roof permit, with no description or only an administrative note, also counts.',
            always_brings: [],
        },
        {
            tag: 'roof_repair',
            family: 'structure',
            description: 'Identifies permits or records for partial roof repairs such as patches, leak repair, flashing repair, or localized damaged-decking work.',
            always_brings: [],
        },
        {
            tag: 'kitchen',
            family: 'structure',
            description: 'Identifies permits or records for kitchen construction or remodeling.',
            always_brings: [],
        },
        {
            tag: 'bath',
            family: 'structure',
            description: 'Identifies permits or records for bathroom construction or remodeling.',
            always_brings: [],
        },
        {
            tag: 'foundation',
            family: 'structure',
            description: 'Identifies permits or records for foundation, footing, underpinning, or comparable building-foundation work.',
            always_brings: ['structural'],
        },
        {
            tag: 'signage',
            family: 'structure',
            description: 'Identifies permits or records for sign, banner, awning-sign, or related signage permits.',
            always_brings: [],
        },
        {
            tag: 'manufactured_home',
            family: 'structure',
            description: 'Identifies permits or records for manufactured, mobile, modular, or factory-built homes and their qualifying installations.',
            always_brings: [],
        },
        {
            tag: 'residential',
            family: 'property',
            description: 'Identifies permits or records for residential housing or dwelling work. Text that is explicitly non-residential, or that mentions housing only in passing, does not count.',
            always_brings: [],
        },
        {
            tag: 'non_residential',
            family: 'property',
            description: 'Identifies permits or records for commercial, institutional, industrial, or other explicitly non-residential occupancy or work.',
            always_brings: [],
        },
        {
            tag: 'multi_family',
            family: 'property',
            description: 'Identifies permits or records for multi-family residential projects such as apartments, condominiums, townhomes, triplexes, and larger unit-count housing.',
            always_brings: ['residential'],
        },
        {
            tag: 'adu',
            family: 'property',
            description: 'Identifies permits or records for an accessory dwelling unit, including ADUs, JADUs, granny flats, in-law units, and qualifying guest houses or casitas.',
            always_brings: [],
        },
        {
            tag: 'short_term_rental',
            family: 'property',
            description: 'Identifies short-term, vacation, nightly, or transient-rental licensing, registration, zoning, and related records.',
            always_brings: [],
        },
        {
            tag: 'food_service',
            family: 'property',
            description: 'Identifies any permit or record at a food-service business, such as a named restaurant, cafe, bakery, chain or concession, or a food-establishment or health permit, whatever the work. A permit that names such a business also carries non_residential.',
            always_brings: [],
        },
        {
            tag: 'cannabis',
            family: 'property',
            description: 'Identifies permits or records for cannabis or hemp cultivation, processing, retail, operations, licensing, or registration.',
            always_brings: [],
        },
        {
            tag: 'data_center',
            family: 'property',
            description: 'Identifies permits or records for data-center facilities or their specialized data-hall, cooling, or power infrastructure.',
            always_brings: [],
        },
        {
            tag: 'hazard_mitigation',
            family: 'hazard',
            description: 'Identifies permits or records for hazard-mitigation work of any kind; it appears whenever storm preparation, flood mitigation, seismic retrofit or wildfire mitigation is present.',
            always_brings: [],
        },
        {
            tag: 'flood_mitigation',
            family: 'hazard',
            description: 'Identifies permits or records for physical flood-mitigation work, including flood vents, floodproofing, structure elevation, drainage, and qualifying waterproofing.',
            always_brings: ['hazard_mitigation'],
        },
        {
            tag: 'seismic_retrofit',
            family: 'hazard',
            description: 'Identifies permits or records for seismic strengthening such as soft-story work, brace-and-bolt, foundation bolting, URM retrofit, or earthquake shutoff systems.',
            always_brings: ['hazard_mitigation'],
        },
        {
            tag: 'storm_prep',
            family: 'hazard',
            description: 'Identifies permits or records for hurricane and storm hardening such as qualifying shutters, opening protection, roof straps, safe rooms, and storm shelters.',
            always_brings: ['hazard_mitigation'],
        },
        {
            tag: 'wildfire',
            family: 'hazard',
            description: 'Identifies permits or records for wildfire and wildland-urban interface (WUI) mitigation such as ember resistance, defensible space, home hardening, fuel modification, or fire-resistant exterior components.',
            always_brings: ['hazard_mitigation'],
        },
        {
            tag: 'asbestos',
            family: 'hazard',
            description: 'Identifies permits or records for asbestos-related permitting or abatement.',
            always_brings: [],
        },
        {
            tag: 'lead_abatement',
            family: 'hazard',
            description: 'Identifies permits or records for lead-paint or lead-abatement work.',
            always_brings: [],
        },
        {
            tag: 'flood_zone',
            family: 'hazard',
            description: 'Identifies permits or records for a record associated with a flood zone or special flood-hazard area.',
            always_brings: [],
        },
        {
            tag: 'coastal_zone',
            family: 'hazard',
            description: 'Identifies permits or records for work associated with a coastal zone or coastal-commission process.',
            always_brings: [],
        },
        {
            tag: 'historic_district',
            family: 'hazard',
            description: "Identifies historic-district, landmark, preservation, overlay or certificate-of-appropriateness review. Archive labels such as 'Historical Building' or 'Historic Permits' do not count.",
            always_brings: [],
        },
        {
            tag: 'green_certified',
            family: 'hazard',
            description: 'Identifies permits or records for green-building certification or standards such as LEED, net-zero, or Passive House.',
            always_brings: [],
        },
        {
            tag: 'accessibility',
            family: 'hazard',
            description: 'Identifies permits or records for accessibility-related work, such as ADA improvements, accessibility upgrades, or qualifying ramps and lifts.',
            always_brings: [],
        },
        {
            tag: 'administrative',
            family: 'record',
            description: 'Identifies administrative-only or voided records: fee-only entries, information, address or public-records requests, void, cancelled, duplicate or test records, and legacy or archive placeholders with no described scope. A voided record keeps the tags for the work it describes.',
            always_brings: [],
        },
        {
            tag: 'non_building_record',
            family: 'record',
            description: "Identifies an administrative or regulatory record with no supported construction work; it always appears with a tag giving the reason, such as right_of_way, license_registration, code_enforcement, planning, inspection_only, certificate, zoning, garage_sale, administrative (except a legacy or archive placeholder, which carries administrative alone), or a reason taken from the jurisdiction's own record type (stored as a prefixed reason value in the tags column). A cell tower or antenna named on a planning, zoning or administrative record is that record's subject, not construction work, and a planning, zoning or void reference inside a telecom building permit does not make it non-building.",
            always_brings: [],
        },
        {
            tag: 'inspection_only',
            family: 'record',
            description: 'Identifies records whose only purpose is an inspection, such as an inspection or reinspection fee or request, a power release, an annual or periodic inspection, a backflow test, a Title 5 or rental inspection, or an occupancy-inspection record with no construction permit, change of occupancy, temporary CO or work. A construction permit that merely uses a private inspector is not inspection-only, and any work the record describes keeps its own tags.',
            always_brings: [],
        },
        {
            tag: 'certificate',
            family: 'record',
            description: 'Identifies certificate records, such as a certificate of occupancy or completion (CofO, TCO, temporary or final CO), an occupancy permit, or a re-occupancy, resale or rental occupancy inspection; such inspection records also carry inspection_only, and a certificate with no work also carries non_building_record. A mention that a project needs, or does not need, a certificate (for example work required before the certificate of occupancy is issued, or no change to it), or a reference to another occupancy permit, does not count.',
            always_brings: [],
        },
        {
            tag: 'code_enforcement',
            family: 'record',
            description: 'Identifies code-enforcement, violation, complaint, stop-work, after-the-fact, red-tag, nuisance, citation, condemnation, legalization and abatement records rather than ordinary construction permits. Tax, water, sewer, fee, noise, graffiti and asbestos abatement do not count.',
            always_brings: [],
        },
        {
            tag: 'license_registration',
            family: 'record',
            description: 'Identifies business, rental, contractor, vendor, occupational, operating and similar license and registration records rather than construction permits, including health and food-establishment permits, mobile-food and food-truck vendor permits, and itinerant, peddler, solicitor and merchant licenses. The equipment or facility being licensed (a pool, spa, boiler, elevator or food establishment) is the subject of the license, not construction work, while a remodel, build-out, grease trap or hood system at a food business is still construction.',
            always_brings: [],
        },
        {
            tag: 'planning',
            family: 'record',
            description: 'Identifies permits or records for planning and land-use cases such as subdivisions, plats, variances, use permits, home occupations, design review, rezoning, lot splits, and site-plan review; a recorded-plat or site-plan note inside a building/septic permit is not a planning case.',
            always_brings: [],
        },
        {
            tag: 'zoning',
            family: 'record',
            description: 'Identifies a zoning action, such as a zoning permit, approval, clearance, compliance check, verification, letter, review, certificate, variance, appeal, sign-off, rezoning or zone change. A passing zoning mention, such as a zoning district label, a zoning lot, zoning drawings or a note that work conforms to zoning, does not count.',
            always_brings: [],
        },
        {
            tag: 'right_of_way',
            family: 'record',
            description: 'Identifies permits or records for right-of-way, encroachment, street-opening, closure, traffic-control, curb-cut, or comparable public-way permits.',
            always_brings: [],
        },
        {
            tag: 'expedited',
            family: 'record',
            description: 'Identifies an expedited, fast-track, express, easy-permit/no-plan-review or similar quick permit-review process.',
            always_brings: [],
        },
        {
            tag: 'over_the_counter',
            family: 'record',
            description: 'Identifies an over-the-counter / OTC permit process, including "no plan check", "no plan review", "no plans required", walk-in/walk-through and counter-permit lanes.',
            always_brings: [],
        },
        {
            tag: 'temporary',
            family: 'record',
            description: 'Identifies permits or records for temporary power, poles, service, generators, structures, tents, event installations, or construction trailers.',
            always_brings: [],
        },
        {
            tag: 'garage_sale',
            family: 'record',
            description: 'Identifies permits or records for garage-sale, yard-sale, estate-sale, or rummage-sale permits.',
            always_brings: [],
        },
        {
            tag: 'unsubmitted_draft',
            family: 'record',
            description: "Identifies an application a citizen started in the online permit portal but never submitted to the jurisdiction (no record number and no submission date). The record is kept with the tags for the work it describes; this tag comes from the record's status, not its text.",
            always_brings: [],
        },
    ],
};
//# sourceMappingURL=tagData.js.map